import { __awaiter } from "tslib";
import React, { useCallback, useEffect, useState } from 'react';
import { cellStyle } from './GridCellComponent.styles';
import { useAppDispatch, useAppSelector } from '../../store/app.store';
//import { useMasterData } from '../../Utils/ContextHelper';
//import { assignmentDetailsSelectorById } from '../../Store/Slices/assignmentDetailsSlice';
//import { dateRangeSelector } from '../../store/Slices/DateNavigationSlice';
import { Stack } from '@fluentui/react';
import { selectGridCellByRowIdAndColumnId, updateGridCells } from '../../store/Slices/GridCellSlice';
import { FontIcon } from '@fluentui/react/lib/Icon';
import { debounce } from 'lodash';
//import { postForecastQueue } from '../../Services/ForecastService';
import { TelemetryService } from '../../services/TelemetryService';
function GridCellComponent({ cellDetails }) {
    const [inputValue, setInputValue] = React.useState(cellDetails === null || cellDetails === void 0 ? void 0 : cellDetails.primaryValue);
    const [previousValue, setPreviousValue] = React.useState(cellDetails === null || cellDetails === void 0 ? void 0 : cellDetails.primaryValue);
    const dispatch = useAppDispatch();
    /*const {profileDetails} = useMasterData();
    const assignmentDetails = useAppSelector(assignmentDetailsSelectorById(cellDetails.rowId.toString()));
    const dateRange = useAppSelector(dateRangeSelector);*/
    const gridCellState = useAppSelector(selectGridCellByRowIdAndColumnId(cellDetails.rowId, cellDetails.columnId));
    const [isSavingFlag, setSavingFlag] = useState(false);
    const [isNewlyUpdatedFlag, setNewlyUpdatedFlag] = useState(false);
    const [isInputDirty, setInputDirty] = useState(false);
    const telemetryService = TelemetryService.getInstance();
    /*const telemetryService = new TelemetryService();
    const methodName = "GridCellComponent";
    const [logEvents] = React.useState(
            telemetryService.createPropertyBag()
    );*/
    const debouncedUpdateCell = useCallback(debounce((value, previousValue) => {
        if (value !== '' && value !== previousValue.toString()) {
            updateCell(value, previousValue);
        }
        else {
            dispatch(updateGridCells([{ rowId: cellDetails.rowId, columnId: cellDetails.columnId, currValue: Number(previousValue), prevValue: Number(previousValue), isSaving: false, isNewlyUpdated: false, isInputDirty: false }]));
        }
    }, 1000), []);
    const onChange = (event) => {
        if (Number(event.target.value) < 0 || Number(event.target.value) > 1000) {
            return;
        }
        setInputDirty(true);
        const updatedValue = event.target.value.replace(/\D/g, '');
        setInputValue(updatedValue);
        if (gridCellState && gridCellState.valuePostUpdate) {
            debouncedUpdateCell(updatedValue, gridCellState.valuePostUpdate.toString());
        }
        else {
            debouncedUpdateCell(updatedValue, cellDetails.primaryValue);
        }
    };
    const updateCell = (updatedValue, previousValue) => __awaiter(this, void 0, void 0, function* () {
        if (updatedValue !== '' && updatedValue !== previousValue.toString()) {
            let updateForecastData = [];
            updateForecastData.push({
                cellDate: cellDetails.columnId,
                userForecast: Number(updatedValue),
                pjmForecast: cellDetails.additionalDetails,
                changeDiff: Number(updatedValue) - Number(previousValue)
            });
            dispatch(updateGridCells([{ rowId: cellDetails.rowId, columnId: cellDetails.columnId, currValue: Number(updatedValue), prevValue: Number(previousValue), isSaving: true, isNewlyUpdated: false, isInputDirty: true }]));
        }
        else if (updatedValue === previousValue.toString()) {
            // If the value is the same as the previous value, we can reset the state
            dispatch(updateGridCells([{ rowId: cellDetails.rowId, columnId: cellDetails.columnId, currValue: Number(updatedValue), prevValue: Number(previousValue), isSaving: false, isNewlyUpdated: false, isInputDirty: false }]));
        }
    });
    const onBlur = (event) => {
        if (inputValue === '') {
            setInputValue(gridCellState.valuePostUpdate ? gridCellState.valuePostUpdate.toString() : previousValue); // Use the last saved/updated value
            dispatch(updateGridCells([{ rowId: cellDetails.rowId, columnId: cellDetails.columnId, currValue: gridCellState.prevValue, prevValue: gridCellState.prevValue, isSaving: false, isNewlyUpdated: false, isInputDirty: false }]));
        }
    };
    const onFocus = (event) => {
        event.target.select();
    };
    const displayOnHover = () => {
        if (cellDetails.lastUpdatedBy === '') {
            return;
        }
        else if (cellDetails.isPastView) {
            return 'Actuals';
        }
        else {
            return cellDetails.lastUpdatedBy;
        }
    };
    useEffect(() => {
        if (gridCellState) {
            setInputValue(gridCellState.currValue.toString());
            setPreviousValue(gridCellState.prevValue.toString());
            setNewlyUpdatedFlag(gridCellState.isNewlyUpdated || false);
            setSavingFlag(gridCellState.isSaving || false);
        }
        else {
            setInputValue(cellDetails.primaryValue);
            setPreviousValue(cellDetails.primaryValue);
            setNewlyUpdatedFlag(false);
            setSavingFlag(false);
        }
    }, [gridCellState, cellDetails]);
    return (React.createElement(Stack, { styles: cellStyle, horizontal: true },
        isSavingFlag && React.createElement(FontIcon, { "aria-label": "Update in progress glimmer", iconName: "Glimmer", className: 'cell-glimmer' }),
        React.createElement("div", { className: 'cell-div', style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'absolute',
                top: '50%',
                left: '50%',
                width: '30px',
                height: '30px',
                transform: 'translate(-50%, -50%)',
            } },
            React.createElement("input", { className: 'cell-input', tabIndex: (cellDetails === null || cellDetails === void 0 ? void 0 : cellDetails.isInputDisabled) ? -1 : 0, type: "text", id: `gridCell_row_${cellDetails.rowId}_col_${cellDetails.columnId}`, name: "Grid Cell Input", pattern: "\\d+", onChange: onChange, onBlur: onBlur, onFocus: onFocus, "aria-label": "Enter forecast hours", value: inputValue, disabled: cellDetails === null || cellDetails === void 0 ? void 0 : cellDetails.isInputDisabled, title: displayOnHover() }),
            ((cellDetails === null || cellDetails === void 0 ? void 0 : cellDetails.isAdditionalDetailsEnabled) || (cellDetails === null || cellDetails === void 0 ? void 0 : cellDetails.isPastView)) &&
                (React.createElement("div", { id: "additionalDetailsInput", style: { border: 'none', outline: 'none', flex: 1 } }, (cellDetails === null || cellDetails === void 0 ? void 0 : cellDetails.isPastView) ?
                    (cellDetails === null || cellDetails === void 0 ? void 0 : cellDetails.additionalDetails) ? `(${cellDetails === null || cellDetails === void 0 ? void 0 : cellDetails.additionalDetails})` : ''
                    :
                        `| ${cellDetails === null || cellDetails === void 0 ? void 0 : cellDetails.additionalDetails}`)))));
}
export default GridCellComponent;
//# sourceMappingURL=GridCellComponent.js.map